import {
  AloftPrice,
  ManualAdjustmentKey,
  ORDER_FEATURES,
  orUndefined,
  schAloftPrice,
} from '@aloft/toolkit-shared';

import { CompAdjustments } from '../../../../redux/features/selectors/CompAdjustments.ts';
import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';

type SubjectData = SubjectPropertyDataState['subjectData']['editableData'];
type CompData = CompPropertyDataState['compData']['editableData'];

export type CompPresenceAdjustmentCheck = {
  label: string;
  cellKey: ManualAdjustmentKey;
  subjectHasFeature: (subject: SubjectData) => boolean;
  compHasFeature: (comp: CompData) => boolean;
  getAdjustment: (compAdjustments: CompAdjustments) => AloftPrice | undefined;
};

export const COMP_PRESENCE_ADJUSTMENT_CHECKS: CompPresenceAdjustmentCheck[] = [
  {
    label: 'Pool/Spa',
    cellKey: 'poolSpa',
    subjectHasFeature: (s) =>
      ORDER_FEATURES.pool.hasFeature(s.improvements) ||
      ORDER_FEATURES.spa.hasFeature(s.improvements),
    compHasFeature: (c) =>
      ORDER_FEATURES.pool.hasFeature(c.improvements) ||
      ORDER_FEATURES.spa.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.pool?.adjustment),
  },
  {
    label: 'Porch/Patio/Deck',
    cellKey: 'porchPatioDeck',
    subjectHasFeature: (s) =>
      ORDER_FEATURES.porch.hasFeature(s.improvements) ||
      ORDER_FEATURES.patio.hasFeature(s.improvements) ||
      ORDER_FEATURES.deck.hasFeature(s.improvements),
    compHasFeature: (c) =>
      ORDER_FEATURES.porch.hasFeature(c.improvements) ||
      ORDER_FEATURES.patio.hasFeature(c.improvements) ||
      ORDER_FEATURES.deck.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.porchPatioDeck?.adjustment),
  },
  {
    label: 'Attic',
    cellKey: 'attic',
    subjectHasFeature: (s) => ORDER_FEATURES.attic.hasFeature(s.improvements),
    compHasFeature: (c) => ORDER_FEATURES.attic.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.attic?.adjustment),
  },
  {
    label: 'Fireplace',
    cellKey: 'fireplace',
    subjectHasFeature: (s) => ORDER_FEATURES.fireplace.hasFeature(s.improvements),
    compHasFeature: (c) => ORDER_FEATURES.fireplace.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.fireplace?.adjustment),
  },
  {
    label: 'Barn',
    cellKey: 'barn',
    subjectHasFeature: (s) => ORDER_FEATURES.barn.hasFeature(s.improvements),
    compHasFeature: (c) => ORDER_FEATURES.barn.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.barn?.adjustment),
  },
  {
    label: 'Shed',
    cellKey: 'shed',
    subjectHasFeature: (s) => ORDER_FEATURES.shed.hasFeature(s.improvements),
    compHasFeature: (c) => ORDER_FEATURES.shed.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.shed?.adjustment),
  },
  {
    label: 'Workshop',
    cellKey: 'workshop',
    subjectHasFeature: (s) => ORDER_FEATURES.workshop.hasFeature(s.improvements),
    compHasFeature: (c) => ORDER_FEATURES.workshop.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.workshop?.adjustment),
  },
  {
    label: 'ADU',
    cellKey: 'adu',
    subjectHasFeature: (s) => ORDER_FEATURES.adu.hasFeature(s.improvements),
    compHasFeature: (c) => ORDER_FEATURES.adu.hasFeature(c.improvements),
    getAdjustment: (ca) => orUndefined(schAloftPrice.parse)(ca.adu?.adjustment),
  },
];
